import React from 'react'
import Dropzone from 'react-dropzone'

import { Popover } from 'antd'

import { Button, Input, InputGroup, Loader, Panel, PanelGroup } from 'rsuite'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { Divider, IconButton, Stack } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'

import { BootstrapTooltip } from '../../../_ui/tooltip'
import empty from './../../../../img/empty_documents.svg'
import Empty from '../../../_ui/empty'
import css from './students.module.scss'

const Sudents = (props: any) => {
    return (
        <div className={css.main}>
            <div className={css.mainHeader}>
                <div style={{ margin: "auto 0" }}>Студенты группы {props.groupName} ({props.groupYear})</div>

                <InputGroup inside style={{ width: "350px" }} disabled={props.studentsList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="ФИО студента..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.getFilterStudentFIO}
                        onChange={value => props.setFilterStudentFIO(value)}
                    />

                    {props.getFilterStudentFIO &&
                        <InputGroup.Addon onClick={() => props.setFilterStudentFIO('')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <div className={css.mainBody}>
                <div className={css.thead}>
                    <div style={{ margin: "auto 5px" }}></div>
                    <div style={{ margin: "auto 5px" }}>ФИО студента</div>
                    <div style={{ margin: "auto 5px" }}>Специальность и специализация студента</div>
                </div>

                <div className={css.tbody}>
                    <PanelGroup accordion activeKey={props.selectedStudentID} onSelect={props.onSelectedStudent}>
                        {!props.studentsList.length
                            ? <Empty image={empty} description="Студенты отсутствуют" />
                            : props.studentsList.filter((val: any) => {
                                let stringReturn

                                let lastName = val.lastName.toLowerCase().includes(props.getFilterStudentFIO.toLowerCase())
                                let firstName = val.firstName.toLowerCase().includes(props.getFilterStudentFIO.toLowerCase())
                                let secondName = val.secondName.toLowerCase().includes(props.getFilterStudentFIO.toLowerCase())

                                if (lastName || firstName || secondName) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((student: any) => {
                                return (
                                    <Panel key={student.studentID} eventKey={student.studentID} id={student.studentID} header={
                                        <div className={css.trow}>
                                            <div style={{ margin: "auto 5px", textAlign: "center" }}>{student.studentNumber}</div>
                                            <div style={{ margin: "auto 5px", lineHeight: "25px" }}>
                                                <div>{student.lastName}</div>
                                                <div>{`${student.firstName} ${student.secondName}`}</div>
                                            </div>

                                            <div style={{ margin: "auto 5px", lineHeight: "25px" }}>
                                                <div>{student.nameSpecialty}</div>
                                                <div>{student.nameSpecialization}</div>
                                            </div>
                                        </div>}>

                                        <div className={css.studentFiles}>
                                            <div className={css.sfHead}>
                                                <div style={{ margin: "auto 0" }}>Имя файла</div>
                                                <div style={{ margin: "auto 10px", textAlign: "center" }}>Дата создания</div>
                                                <div style={{ margin: "auto 0", textAlign: "right" }}></div>
                                            </div>

                                            <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'portfolio')}>
                                                {({ getRootProps, isDragAccept, isDragActive }) => (
                                                    <div {...getRootProps({ className: isDragAccept ? `${css.sfBody} dropZone` : `${css.sfBody}`, onClick: event => event.stopPropagation() })}>
                                                        {isDragActive
                                                            ? <div style={{ margin: "auto 0" }}>Перетащите сюда файлы с расширением <b>".pdf"</b></div>
                                                            : props.isVisibleLoaderFiles
                                                                ? <div style={{ height: "250px", position: "relative", background: "#fff" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                                                                : !props.filesList.length
                                                                    ? <Empty image={empty} description="Файлы отсутствуют" heightBox="200px" heightImg="150px" />
                                                                    : props.filesList.map((file: any) => {
                                                                        return (
                                                                            <div key={file.filetID} className={css.sfRow}>
                                                                                <div style={{ margin: "auto 0" }}>{file.fileName}</div>
                                                                                <div style={{ margin: "auto 10px", textAlign: "center" }}>{file.fileCreateDate}</div>

                                                                                <div style={{ margin: "auto 0", display: "flex", gap: "5px" }}>
                                                                                    <a href={file.fileUrl} target="_blank" rel="noreferrer">
                                                                                        <BootstrapTooltip title={`Открыть файл ${file.fileName}`} placement="top" arrow>
                                                                                            <IconButton size="small" sx={{ color: "#1890ff", m: "auto 0" }}>
                                                                                                <FileDownloadOutlinedIcon />
                                                                                            </IconButton>
                                                                                        </BootstrapTooltip>
                                                                                    </a>

                                                                                    <Popover placement="bottomRight" trigger="click"
                                                                                        content={
                                                                                            <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                                                                <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Удалить этот файл?</div>

                                                                                                <Button appearance="primary" size="lg"
                                                                                                    onClick={() => props.onClickButtonDeleteFile(file.filetID)}
                                                                                                >ДА</Button>
                                                                                            </Stack>
                                                                                        }>

                                                                                        <div>
                                                                                            <BootstrapTooltip title={`Удалить файл ${file.fileName}`} placement="top" arrow>
                                                                                                <IconButton size="small" sx={{ color: "#1890ff", m: "auto 0" }}>
                                                                                                    <DeleteOutlinedIcon />
                                                                                                </IconButton>
                                                                                            </BootstrapTooltip>
                                                                                        </div>
                                                                                    </Popover>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                        }
                                                    </div>
                                                )}
                                            </Dropzone>

                                            <div className={css.studentFilesFooter}>
                                                <div className={css.footerItem1}>
                                                    <div className={css.head}>ДОПУСТИМЫЕ ПРЕФИКСЫ В ИМЕНИ ФАЙЛА</div>
                                                    
                                                    <div className={css.item}>
                                                        НИР, КП, КР, Реф, Реф(рец), УП, ПрП, ПП, УП(д), УП(о), ПрП(д), ПрП(о), ПП(д),<br/>
                                                        ПП(о), УП(ох), ПрП(ох), ПП(ох), НИП(график), НИП(инд.задание), НИП(дневник), НИП(отчет),<br/>
                                                        ПП(график), ПП(инд.задание), ПП(дневник), ПП(отчет), НИР(д), НИР(ох), НИР(о), Д
                                                    </div>
                                                </div>

                                                <div className={css.itemOther}>
                                                    Пример имени файла: НИР_{student.lastName + student.firstName.substring(0, 1) + student.secondName.substring(0, 1)}_Газоснабжение.pdf
                                                </div>

                                                <div className={css.itemOther}>
                                                    Перетащите файлы с расширением <b>".pdf"</b> в область таблицы или нажмите эту кнопку:

                                                    <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'portfolio')}>
                                                        {({ getRootProps }) => (
                                                            <Button size="sm" appearance="link" {...getRootProps()}>ВЫБРАТЬ ФАЙЛЫ</Button>
                                                        )}
                                                    </Dropzone>
                                                </div>
                                            </div>
                                        </div>
                                    </Panel>
                                )
                            })
                        }
                    </PanelGroup>
                </div>
            </div>
        </div>
    )
}

export default Sudents